import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenuService } from '../../services/menu.service';
import { TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { first } from 'rxjs/operators';
import { LoggedUser } from '../../common/logged-user.service';
import { cloneDeep } from "lodash";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  providers: [TranslocoPipe],
  encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnInit {

  @Input() showMenu: boolean;

  public items: MenuItem[];
  public selectedFirstLevelItem: MenuItem;
  public minimizedFirstLevel: boolean;
  public fadeInFlag: boolean;
  public hoverFirstLevelFlag: boolean;
  public selectedSecondLevelItem: boolean = false;

  constructor(
    private menuService: MenuService,
    private translocoService: TranslocoService,
    private loggedUser: LoggedUser,
    private router: Router
  ) {
    this.minimizedFirstLevel = false;
    this.fadeInFlag = true;
    this.hoverFirstLevelFlag = false;
  }

  ngOnInit(): void {
    this.loadItems();
    this.applyRouteToMenuState();
  }

  private loadItems(): void {
    this.loggedUser.userObservable.subscribe(() => this.refreshItems());
    this.translocoService.langChanges$.subscribe(() => this.refreshItems());
  }

  private applyRouteToMenuState(): void {
    const splitUrl = this.router.url.split('/');
    const firstLevel = splitUrl[1];
    if (firstLevel) {
      const firstLevelFound = this.items.find(item => item.routerLink.replace('/', '') === firstLevel);
      if (firstLevelFound) {
        this.selectFirstLevelItem(firstLevelFound);
      }
    } else {
      const firstLevelFound = this.items.find(item => item.routerLink === '/');
      if (firstLevelFound) {
        this.selectFirstLevelItem(firstLevelFound);
      }
    }
  }

  private refreshItems(): void {
    this.items = cloneDeep(this.menuService.getItems());
  }

  public selectFirstLevelItem(item: MenuItem, event?: MouseEvent) {
    this.selectedSecondLevelItem = false;
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.menuService.firstLevelChangeEmitter.emit(item);
    this.selectedFirstLevelItem = item;
    if (item.items) {
      this.minimizedFirstLevel = true;
      this.fadeInFlag = false;
      setTimeout(() => this.fadeInFlag = true);
    } else {
      if (event) {
        this.router.navigate([item.routerLink]);
      }
      this.minimizedFirstLevel = false;
    }
  }

  public selectSecondLevelItem(item: MenuItem, event?: MouseEvent) {
    this.selectedSecondLevelItem = true;
  }

  public onFirstLevelMouseEnter() {
    if (this.minimizedFirstLevel) {
      this.minimizedFirstLevel = false;
      this.hoverFirstLevelFlag = true;
    }
  }

  public onFirstLevelMouseLeave() {
    if (this.hoverFirstLevelFlag && this.selectedFirstLevelItem?.items) {
      this.minimizedFirstLevel = true;
      this.hoverFirstLevelFlag = false;
    }
  }

}
